import { render, staticRenderFns } from "./Agencies.vue?vue&type=template&id=6d2ecdc2"
import script from "./Agencies.vue?vue&type=script&lang=ts"
export * from "./Agencies.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports